<template>
  <section id="gallery">
    <h3 class="text-3xl md:text-6xl leading-tight mb-6 p-4 md:p-0 lg:mb-12 ">
      Thank you to everyone who has sent their love.
    </h3>
    <div class="gallerywrap flex flex-wrap mx-auto">
      <Heart
        v-for="(h,i) in hearts"
        :key="h.id"
        :hid="h.id"
        :index="i"
        :artist="h.artist"
        :hash="h.image.private_hash"
        class="floatingheart relative md:w-1/3 lg:w-1/3 xl:w-1/4 flex justify-center items-center mb-4 max-w-24"
        figstyles="bg-white m-2 p-2 pb-4 h-full w-full flex flex-shrink-1 justify-center items-start"
      />
    </div>
  </section>
</template>

<script>
import mediumZoom from "medium-zoom";
import Heart from "@/components/Heart.vue";
// import GalleryModal from "@/components/GalleryModal.vue";
// import Spinner from '@/components/Spinner.vue';

export default {
  name: "Gallery",
  props: ["hearts"],
  components: {
    Heart,
    // Spinner,
    // GalleryModal
  },
  data() {
    return {
      show: true,
    };
  },
  updated() {
    // mediumZoom("#gallery img", {
    //   margin: 24,
    //   background: "#ffd4ce",
    //   scrollOffset: 0,
    //   //   template: '#zoom-template'
    // });
  },methods:{
    showDetail(){

    }
  }
};
</script>

<style scoped>
.gallerywrap{
  max-width:1380px;

}
</style>
